import { render, staticRenderFns } from "./TailwindSpinner.vue?vue&type=template&id=6c94b830&"
import script from "./TailwindSpinner.vue?vue&type=script&lang=js&"
export * from "./TailwindSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports